export const DATA = {
    orderStatus: [
        { value: 3, name: 'Chờ báo giá', color: '#9e5959', orderIndex: 1 },
        { value: 0, name: 'Chờ đặt cọc', color: 'red', orderIndex: 2 },
        { value: 2, name: 'Đã đặt cọc', color: 'green', orderIndex: 3 },
        { value: 5, name: 'Đã mua hàng', color: '#2bbae4', orderIndex: 4 },
        { value: 16, name: 'Đang đến kho gửi', color: '#f7819f', orderIndex: 5 },
        { value: 11, name: 'Nhập kho gửi', color: '#7a8498', orderIndex: 6 },
        { value: 12, name: 'Đang về kho nhận', color: '#7a8498', orderIndex: 7 },
        { value: 7, name: 'Nhập kho nhận', color: 'orange', orderIndex: 8 },
        { value: 9, name: 'Đã xuất kho', color: 'blue', orderIndex: 9 },
        { value: 13, name: 'Khiếu nại', title: 'Đã khiếu nại', color: '#9732f3', orderIndex: 10 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 11 },
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 12 },
    ],
    depositStatus: [
        { value: 16, name: 'Đang đến kho gửi', color: '#f7819f', orderIndex: 1 },
        { value: 11, name: 'Nhập kho gửi', color: '#7a8498', orderIndex: 2 },
        { value: 12, name: 'Đang về kho nhận', color: '#7a8498', orderIndex: 3 },
        { value: 7, name: 'Nhập kho nhận', color: 'orange', orderIndex: 4 },
        { value: 9, name: 'Đã xuất kho', color: 'blue', orderIndex: 5 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 6 },
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 7 },
        { value: 13, name: 'Khiếu nại', title: 'Đã khiếu nại', color: '#9732f3', orderIndex: 10 },
    ],
    payserviceStatus: [
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 1 },
        { value: 2, name: 'Chờ báo giá', color: '#f7819f', orderIndex: 2 },
        { value: 3, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 3 },
        { value: 4, name: 'Đã thanh toán', color: 'orange', orderIndex: 4 },
        { value: 5, name: 'Hoàn thành', color: '#7a8498', orderIndex: 5 },
    ],
    payauthorityStatus: [
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 1 },
        { value: 2, name: 'Chờ báo giá', color: '#f7819f', orderIndex: 2 },
        { value: 3, name: 'Chờ ủy quyền', color: '#FACC2E', orderIndex: 3 },
        { value: 4, name: 'Khiếu nại', color: '#D358F7',     orderIndex: 4 },
        { value: 5, name: 'Xác nhận thanh toán', color: '#FE9A2E', orderIndex: 5 },
        { value: 6, name: 'Hoàn thành', color: '#7a8498', orderIndex: 6 },
    ],
    payauthorityAccounts: [
        { value: 1, name: 'Tao bao 1', color: '#000000', textColor: '#ffffff' },
        { value: 2, name: 'Tao bao 2', color: '#000000', textColor: '#ffffff' },
        { value: 3, name: 'Tao bao 3', color: '#000000', textColor: '#ffffff' },
        { value: 4, name: 'Tao bao 4', color: '#000000', textColor: '#ffffff' },
        { value: 5, name: 'Tao bao 5', color: '#000000', textColor: '#ffffff' },
        { value: 6, name: 'Tao bao 6', color: '#000000', textColor: '#ffffff' },
    ],
    paymentTypeList: [
        { value: 1, name: 'Trực tiếp', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Ví', color: '#0059b3', textColor: '#FFF' },
    ],
    paymentStatusList: [
        { value: 2, name: 'Đặt cọc', color: '#808080', textColor: '#000' },
        { value: 12, name: 'Nhận lại cọc', color: '#e63900', textColor: '#000' },
        { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
        { value: 10, name: 'Thanh toán ship', color: '#7a8498', textColor: '#FFF' },
    ],
    complainStatusList: [
        { value: 4, name: 'Đã hủy', color: 'black' },
        { value: 1, name: 'Chờ xử lý', color: 'red' },
        { value: 2, name: 'Đang xử lý', color: 'orange' },
        { value: 3, name: 'Đã xử lý', color: 'blue' },
    ],
    complainMethod: [
        { value: 1, name: 'Hoàn tiền', color: 'red' },
        { value: 2, name: 'Hàng hóa thay thế', color: 'blue' }
    ],
    statusAction: [
        { text: 'Hủy đơn hàng', color: '#d9534f', orderStatus: [0, 2] },
        { text: 'Khiếu nại', color: '#9732f3', orderStatus: [9, 13] },
    ],
    statusRecharge: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' },
        { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
        { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
    ],
    statusWithdrawal: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
    ],
    walletTradeType: [
        { value: 1, name: 'Đặt cọc' },
        { value: 2, name: 'Nhận lại tiền đặt cọc' },
        { value: 3, name: 'Thanh toán hóa đơn' },
        { value: 4, name: 'Nạp tiền' },
        { value: 5, name: 'Rút tiền' },
        { value: 6, name: 'Hủy lệnh rút tiền' },
        { value: 7, name: 'Xử lý khiếu nại' }
    ],
    billOfLadingStatus: [
        { value: 1, name: 'Đang đến kho gửi', disabled: false, color: 'black', textColor: '#FFF' },
        { value: 2, name: 'Đã về kho gửi', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 3, name: 'Đang về kho nhận', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 4, name: 'Đã về kho nhận', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 5, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' },
        { value: 13, name: 'Khiếu nại', disabled: false, color: 'purple', textColor: '#FFF' },
    ],
    cancelReason: [ 
        { value: 1, name: "NCC/Shop không có hàng (thời gian chuẩn bị quá lâu)", disabled: false }, 
        { value: 2, name: "Đổi ý không còn nhu cầu", disabled: false },
        { value: 8, name: "Giá cao so với kỳ vọng", disabled: false },
        { value: 9, name: "Sản phẩm Vbimex BG không đạt yêu cầu", disabled: false },
        { value: 3, name: "Lên đơn nhầm", disabled: false },
        { value: 4, name: "Thay đổi số lượng, chủng loại, shop", disabled: false },
        { value: 5, name: "Hàng hóa không đạt, yêu cầu trả lại NCC", disabled: false },
        { value: 6, name: "Vận chuyển Vbimex không kịp tiến độ", disabled: false },
        { value: 7, name: "Lý do khác", disabled: false },
        { value: 10, name: "NV hỗ trợ thiếu nhiệt tình", disabled: true },
    ],
    exportReceiptStatus: [
        { value: 1, name: 'Phiếu nháp', color: '#d9534f', textColor: '#000' },
        { value: 2, name: 'Đã chuẩn bị hàng', color: 'green', textColor: '#FFF' },
        { value: 3, name: 'Hoàn thành', color: 'blue', textColor: '#FFF' }
    ],
    DATA_TYPE: {
        String: 0,
        Number: 1,
        Enum: 2,
        Date: 3
    },
    LIST_COMPARISON: [
        { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
        { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
        { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
        { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
        { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
        { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
        { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
        { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
        { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
        { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
        { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
        { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
        { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
        { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
        { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
        { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
        { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
        { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
    ],
    FEE_CHECK: [
        { value: 1, name: 'Kiểm đếm gói A', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Kiểm đếm gói B', color: '#0059b3', textColor: '#FFF' },
    ]
};
